import { AxiosError } from 'axios';
import { POST_RESET_PASSWORD_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ResetPasswordRequest {
  link: string;
  password: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostResetPassword = ({ onSuccess, onError }: Input) => {
  const postResetPassword = async (data: ResetPasswordRequest) => {
    await axiosClient.post<void>(POST_RESET_PASSWORD_URL, data);
  };

  return useCustomMutation(
    postResetPassword,
    {
      onSuccess,
      onError,
    },
    false
  );
};
